var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "details-view",
      class: { sidebar: _vm.sidebar.opened },
      staticStyle: { overflow: "unset", position: "relative" }
    },
    [
      _vm.showSopIndex
        ? _c(
            "div",
            [
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "tip",
                    style: { paddingBottom: _vm.advertisingLog ? "" : "25px" }
                  },
                  [
                    _c(
                      "el-carousel",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.advertisingLog,
                            expression: "advertisingLog"
                          }
                        ],
                        staticStyle: { width: "auto" },
                        attrs: {
                          height: "30px",
                          direction: "vertical",
                          "indicator-position": "none",
                          arrow: "never",
                          interval: 3000
                        }
                      },
                      _vm._l(_vm.advertisingData, function(item) {
                        return _c("el-carousel-item", { key: item.uuid }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "#ea8749"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.doPage(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.order +
                                    "/" +
                                    _vm.advertisingData.length +
                                    " "
                                )
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "red"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.doPage(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.subjectName + " "))]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "#0C5ED9FF"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.doPage(item)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item.title + " "))]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "16px",
                                color: "red"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.doPage(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.content))]
                          )
                        ])
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "section entry-container-wrapper" }, [
                  _c(
                    "span",
                    { staticClass: "title" },
                    [
                      _vm._v(_vm._s(_vm.$t("Sop.QuickEntry")) + " "),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "bottom",
                            width: "415",
                            trigger: "hover"
                          }
                        },
                        [
                          _c("div", { staticClass: "pop-content" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Sop.QuickEntryPopover.FirstLine"))
                            )
                          ]),
                          _c("div", { staticClass: "pop-content" }, [
                            _vm._v(
                              _vm._s(_vm.$t("Sop.QuickEntryPopover.SecondLine"))
                            )
                          ]),
                          _c("svg-icon", {
                            staticStyle: {
                              "font-size": "14px",
                              "margin-top": "-3px"
                            },
                            attrs: {
                              slot: "reference",
                              "icon-class": _vm.$store.state.settings
                                .isUIPersonalized
                                ? "question-white"
                                : "question"
                            },
                            slot: "reference"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "entry-expand",
                      on: { click: _vm.handleUnfold }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.isUnfold
                              ? _vm.$t("Sop.PackUp")
                              : _vm.$t("Sop.Unfold")
                          )
                        )
                      ]),
                      !_vm.isUnfold
                        ? _c("i", { staticClass: "el-icon-arrow-down" })
                        : _c("i", { staticClass: "el-icon-arrow-up" })
                    ]
                  ),
                  _vm.isUnfold
                    ? _c(
                        "div",
                        {
                          ref: "entryDiv",
                          staticClass: "entry-container-div",
                          on: { drop: _vm.onDrop, dragover: _vm.allowDrop }
                        },
                        _vm._l(_vm.finalEntry, function(entry, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: {
                                position: "relative",
                                display: "flex",
                                "align-items": "center",
                                "flex-direction": "column"
                              },
                              on: {
                                mouseover: function($event) {
                                  _vm.currentFocusEntry = entry
                                },
                                mouseleave: function($event) {
                                  _vm.currentFocusEntry = null
                                },
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toLink(entry)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "entry-div" },
                                [
                                  entry.enTitle === "NoticeBoard" &&
                                  _vm.unreadQuantity > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "notice-unread" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.unreadQuantity > 99
                                                ? "99+"
                                                : _vm.unreadQuantity
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  [
                                    entry.type == "pin"
                                      ? _c("img", {
                                          staticStyle: {
                                            display: "block",
                                            height: "40px",
                                            margin: "12px 0"
                                          },
                                          attrs: { src: entry.icon }
                                        })
                                      : _c("img", {
                                          staticStyle: {
                                            display: "block",
                                            height: "40px",
                                            margin: "12px 0"
                                          },
                                          attrs: {
                                            src:
                                              "" +
                                              _vm.menuIconPath +
                                              (entry.item.meta &&
                                                entry.item.meta.parentIcon.replace(
                                                  "png",
                                                  "svg"
                                                ))
                                          }
                                        })
                                  ],
                                  entry.type != "pin"
                                    ? _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                entry.item.menuId ===
                                                (_vm.currentFocusEntry &&
                                                  _vm.currentFocusEntry.item &&
                                                  _vm.currentFocusEntry.item
                                                    .menuId),
                                              expression:
                                                "\n                  entry.item.menuId ===\n                    (currentFocusEntry &&\n                      currentFocusEntry.item &&\n                      currentFocusEntry.item.menuId)\n                "
                                            }
                                          ],
                                          staticStyle: {
                                            position: "absolute",
                                            top: "-4px",
                                            right: "-4px"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.close(entry)
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-error",
                                            staticStyle: {
                                              color: "#f96a6c",
                                              "font-size": "16px",
                                              "font-weight": "bold"
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                2
                              ),
                              _c(
                                "div",
                                {
                                  style: {
                                    color: "#333",
                                    width: _vm.$selectByLang(
                                      "64px",
                                      "64px",
                                      "64px",
                                      "100px",
                                      "100px",
                                      "100px"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.getTitle(entry)) + " "
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]),
                _c(
                  "div",
                  {
                    staticClass: "section sopWrapper",
                    class: { layer_height: _vm.showLayer }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "board" },
                      [
                        _vm.$store.getters.enableFrontEndPlugin
                          ? _c(
                              "div",
                              [
                                _c("micro-app", {
                                  attrs: {
                                    name: "child-operation-date-query-sopboard",
                                    url:
                                      _vm.$store.getters.frontEndPluginUrl +
                                      "/operationDateQuery",
                                    "router-mode": "pure",
                                    destroy: ""
                                  },
                                  on: {
                                    datachange: _vm.operationDateQueryDataChange
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-tabs",
                          {
                            on: {
                              "tab-click": function($event) {
                                return _vm.loadData(false)
                              }
                            },
                            model: {
                              value: _vm.activateTab,
                              callback: function($$v) {
                                _vm.activateTab = $$v
                              },
                              expression: "activateTab"
                            }
                          },
                          [
                            _c(
                              "el-tab-pane",
                              {
                                key: "warningPending",
                                attrs: {
                                  name: "warningPending",
                                  label: _vm.$t("CargoMsg.Cargo_WarnTodoList")
                                }
                              },
                              [
                                _c("warning-pending", {
                                  ref: "warningPending",
                                  attrs: {
                                    "warning-modules": _vm.warningModules
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            style: {
                              position: "absolute",
                              right: _vm.$selectByLang(
                                "130px",
                                "160px",
                                "150px",
                                "200px",
                                "140px",
                                "120px"
                              ),
                              top: "7px",
                              cursor: "pointer"
                            },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.loadData(true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_LoadData")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "text",
                            staticStyle: {
                              position: "absolute",
                              right: "10px",
                              top: "15px"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("Sop.LastRefreshTime") +
                                    " " +
                                    _vm.finalRefreshTime
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm.pageIsActivated
                  ? _c(
                      "div",
                      { staticClass: "section preWarning-wrapper" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "three-days-logs",
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                staticStyle: {
                                  "margin-bottom": "0px",
                                  "align-self": "center"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_ThreeDaysLogs"))
                                )
                              ]
                            ),
                            _vm.$store.state.settings.isUIPersonalized
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "20px",
                                      "align-self": "center",
                                      color: "#A5EBFF",
                                      "text-decoration": "underline",
                                      cursor: "pointer"
                                    },
                                    on: { click: _vm.viewMoreLogs }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ViewMoreLogs")
                                      )
                                    )
                                  ]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "margin-right": "20px",
                                      "align-self": "center"
                                    },
                                    attrs: { type: "primary" },
                                    on: { click: _vm.viewMoreLogs }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_ViewMoreLogs")
                                      )
                                    )
                                  ]
                                )
                          ],
                          1
                        ),
                        _c("data-update-log", {
                          staticStyle: { height: "442px" },
                          attrs: { source: "HomePage" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c(
                "el-dialog",
                {
                  staticClass: "owe-remind-dialog",
                  attrs: {
                    visible: _vm.oweRemind.visible,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    width: "800px",
                    "show-close": false
                  },
                  on: {
                    "update:visible": function($event) {
                      return _vm.$set(_vm.oweRemind, "visible", $event)
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "owe-remind",
                    style: "background-image: " + _vm.oweRemind.background,
                    domProps: { innerHTML: _vm._s(_vm.oweRemind.content) },
                    on: {
                      "!click": function($event) {
                        return _vm.messageClickHandler($event)
                      }
                    }
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.oweRemind.visibleCloseBtn,
                        expression: "oweRemind.visibleCloseBtn"
                      }
                    ],
                    staticStyle: {
                      cursor: "pointer",
                      position: "absolute",
                      bottom: "30px",
                      right: "30px",
                      width: "155px"
                    },
                    attrs: { src: _vm.close_3 },
                    on: {
                      click: function($event) {
                        _vm.oweRemind.visible = false
                      }
                    }
                  })
                ]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.msgNotifyVisible,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    width: "800px"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.msgNotifyVisible = $event
                    }
                  }
                },
                [
                  _c("div", {
                    staticStyle: { height: "20px" },
                    attrs: { slot: "title" },
                    slot: "title"
                  }),
                  _c("div", { staticStyle: { margin: "10px 20px" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "20px",
                          "font-weight": "bold",
                          height: "50px"
                        }
                      },
                      [_vm._v(" CargoWare基础版 ")]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "orange",
                          "font-size": "16px",
                          height: "30px"
                        }
                      },
                      [
                        _vm._v(
                          " 试用有效期剩余 " + _vm._s(_vm.tryDays) + " 天 "
                        )
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "line-height": "30px",
                          "font-size": "14px"
                        }
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "1、此环境仅用于试用，开通正式环境后，试用数据不会迁移到正式环境中。"
                          )
                        ]),
                        _c("br"),
                        _vm._v(" 2、试用到期后试用账号被锁定不可使用。"),
                        _c("br"),
                        _vm._v(
                          " 3、如决定购买请点击下方【立即购买】按钮，即可在线签约，在线支付，支付"
                        ),
                        _c("br"),
                        _vm._v(" 成功后系统自动开通正式账号，马上使用。"),
                        _c("br")
                      ]
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "105px" },
                        attrs: { src: _vm.buy },
                        on: { click: _vm.gotoBuy }
                      })
                    ]
                  )
                ]
              ),
              _c(
                "el-dialog",
                {
                  attrs: {
                    visible: _vm.reminderVisible,
                    "close-on-click-modal": false,
                    "close-on-press-escape": false,
                    width: "800px",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.reminderVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { height: "20px" },
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [_vm._v("业务提醒")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.reminderVisible = false
                            }
                          }
                        },
                        [_vm._v("关闭")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm.pageIsActivated
                ? _c("montmorill-layer", {
                    attrs: {
                      "show-layer": _vm.showLayer,
                      "scrollbar-width": _vm.scrollbarWidth
                    },
                    on: { handleColseMask: _vm.handleColseMask }
                  })
                : _vm._e()
            ],
            1
          )
        : _c("SopSetting", { on: { closeSopSet: _vm.closeSopSet } }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAnnContent.visible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "800px",
            title: _vm.$t("Message.UpdateNoticeDetails")
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.showAnnContent, "visible", $event)
            },
            close: _vm.closeShowAnnContent
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-anncontent",
              staticStyle: {
                height: "400px",
                "line-height": "15px",
                "overflow-y": "auto"
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", readonly: true },
                domProps: { innerHTML: _vm._s(_vm.showAnnContent.content) }
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showAnnContent.isAutoPop,
                      expression: "showAnnContent.isAutoPop"
                    }
                  ],
                  staticStyle: { "margin-right": "10px" },
                  model: {
                    value: _vm.showAnnContent.chkAuto,
                    callback: function($$v) {
                      _vm.$set(_vm.showAnnContent, "chkAuto", $$v)
                    },
                    expression: "showAnnContent.chkAuto"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.DontRemindMeAgain")))]
              ),
              _c("el-button", { on: { click: _vm.closeShowAnnContent } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.close")))
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.updateNotify.visible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "800px",
            title: _vm.$t("Message.UpdateNoticeDetails")
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.updateNotify, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-anncontent",
              staticStyle: {
                height: "400px",
                "line-height": "15px",
                "overflow-y": "auto"
              }
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", readonly: true },
                domProps: { innerHTML: _vm._s(_vm.updateNotify.content) }
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.btnCloseUpdateNotify } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.close")))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }